import window from 'window-or-global';
const plugin = {
	init(ed) {
		ed.on('Init', () => {
			ed.addCommand(
				'mceConfMacroBrowser',
				window.tinymce.confluence.macrobrowser.macroBrowserToolbarButtonClicked,
			);
		});
	},

	getInfo() {
		return {
			longname: 'Confluence Macro Browser',
			author: 'Atlassian',
			authorurl: 'http://www.atlassian.com',
			version: `${window.tinymce.majorVersion}.${window.tinymce.minorVersion}`,
		};
	},
};

export default function () {
	window.tinymce.create('tinymce.plugins.ConfluenceMacroBrowser', plugin);
	window.tinymce.PluginManager.add(
		'confluencemacrobrowser',
		window.tinymce.plugins.ConfluenceMacroBrowser,
	);
}
